import { render, staticRenderFns } from "./ExamScoreSummary.vue?vue&type=template&id=10cda245&scoped=true"
import script from "./ExamScoreSummary.vue?vue&type=script&lang=js"
export * from "./ExamScoreSummary.vue?vue&type=script&lang=js"
import style0 from "./ExamScoreSummary.vue?vue&type=style&index=0&id=10cda245&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cda245",
  null
  
)

export default component.exports